<ion-app>

    <mea-menu></mea-menu>
    <ion-router-outlet id="main"></ion-router-outlet>

</ion-app>
